/*
 *   File : rm-mapped.js
 *   Author : https://evoqins.com
 *   Description : Rm mapped data tab file
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { Fragment, useState } from 'react';

// custom components
import { CustomDataTable } from '../../../Components/DataTable';


const RmMapped = (props) => {

    const [currentPage, setCurrentPage] = useState(1);

    // handle table page change 
    const _handleTablePageChange = (page_num) => {
        setCurrentPage(page_num);
    };

    // Admins table column 
    const ADMIN_TABLE_COLUMN = [
        {
            name: 'Name',
            selector: row => row.name,
            width: "150px"
        },
        {
            name: 'Email',
            cell: (row) =>
                <a href={`mailto:${row.email}`} target='_blank' className='text-truncate e-text-smoky-black text-decoration-none text-decoration-hover-underline'>
                    {row.email}
                </a>,
            width: "320px"
        },
        {
            name: 'Phone number',
            cell: (row) =>
                <a href={`tel:${row.mobile_number}`} className='e-text-smoky-black text-decoration-none text-decoration-hover-underline'>
                    {row.mobile_number}
                </a>,
            width: "170px"
        },
        {
            name: 'Roles',
            selector: row => row.role,
            width: "150px"
        },
    ];

    return (
        <Fragment>
            <div className='padding-32px-lr padding-32px-top'>
                <h4 className='mb-0 e-text-smoky-black e-primary-font e-font-16 e-font-weight-600 line-height-20px'>
                    Sub admins list
                </h4>
            </div>

            {/* Sub admins data table */}
            <div className='e-data-table-wrapper-default pt-4 pb-5'>
                <CustomDataTable columns={ADMIN_TABLE_COLUMN}
                    data={props.data.rm_mapped_admins}
                    // pagination={ADMIN_DATA.length > 10 ? true : false}
                    // paginationPerPage={10}
                    // paginationTotalRows={ADMIN_DATA.length}
                    onChangePage={_handleTablePageChange} />
            </div>

        </Fragment>
    )
}

export default RmMapped;
